Ext.define('SA.view.menu.AddCountOrPercent', {
    alias: 'widget.add-count-or-percent-menu-item',
    extend: 'Ext.menu.Item',

    disabled: true,

    initComponent() {
        var attribute = SA.data.AttributesCache.get(this.attribute),
            expectedCounterpart = SA.data.ExpectedCounterpartAttributeFactory.create({attribute});

        if (!expectedCounterpart) {
            this.hidden = true;
            this.callParent();
            return;
        }

        this.text = expectedCounterpart.isCount() ? 'Add Count' : 'Add Percent';
        this.expectedCounterpart = expectedCounterpart;
        this.modelHasCounterpart = this.model.getAttributes().some(attribute => expectedCounterpart.isMatch({attribute}));

        this.callParent();
    },

    initEvents() {
        this.callParent();

        this.on('boxready', () => this.initContent());
        this.on('destroy', () => SA.data.AttributesCache.queuePurge());
    },

    handler() {
        this.model.addAttributesAfter({after: this.attribute, attributes: [this.counterpartId]});
        this.model.save();
    },

    initContent() {
        if (this.hidden || this.modelHasCounterpart) {
            return;
        }

        var spinner = this.textEl.appendChild(SA.Html.create({class: 'sa-add-count-or-percent-menu-item-spinner'}));

        this.expectedCounterpart.fetchId().then(id => {
            if (this.isDestroyed) {
                return;
            }
            else if (!id) {
                spinner.remove();
                return;
            }

            SA.data.AttributesCache.await(id).then(() => {
                if (this.isDestroyed) {
                    return;
                }

                spinner.remove();

                this.counterpartId = id;
                this.enable();
            });
        });
    }
});